/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { styled, css, useTheme } from '@mui/material/styles';
import { Stack, Typography, useMediaQuery, Box } from '@mui/material';

const CardsWrapper = styled(Box)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing(5)};

    ${theme.breakpoints.up('sm')} {
      flex-direction: row;

      > div:first-child {
        margin-right: ${theme.spacing(7)};
      }
    }

    > div {
      flex: 1 1 40%;
      margin-bottom: ${theme.spacing(4)};
    }
  `,
);

const TlcWhatIsItSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box className="blue-links">
      <Typography
        variant={isMobile ? 'h3' : 'h2'}
        color="primary"
        component="h2"
        textAlign={{ sm: 'center' }}
        mt={4}
      >
        Téléconsultation médicale : qu’est-ce que c’est ?
      </Typography>

      <CardsWrapper>
        <Box>
          <Typography variant="h5" component="h3">
            Définition de la téléconsultation :
          </Typography>

          <Typography>
            La téléconsultation est une consultation médicale en ligne assurée
            par un professionnel de santé. La consultation s’effectue via une
            plateforme de téléconsultation. Il vous suffit de contacter un
            médecin ou un spécialiste en prenant RDV comme pour une consultation
            en physique, ou bien, en choisissant un professionnel de santé
            disponible immédiatement en téléconsultation sans RDV.
            <br />
            <br />
            Sur Maiia, vous avez la possibilité de prendre un RDV de
            téléconsultation, ou bien, d’entrer tout de suite en contact avec un
            praticien en téléconsultation sans RDV.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h5" component="h3">
            Télémédecine : à l’origine de la consultation en ligne
          </Typography>

          <Typography>
            La consultation en ligne est une des composante de la{' '}
            <a
              href="/teleconsultation/article/la-telemedecine-ca-veut-dire-quoi"
              target="_blank"
              rel="noopener"
            >
              télémédecine
            </a>
            . La télémédecine est l’utilisation de pratiques médicales à
            distance, avec comme objectif d’améliorer la qualité de soin des
            patients. Elle prend en compte :
            <Stack
              spacing={1}
              component="ul"
              sx={{
                margin: ({ spacing }) => spacing(4, 0, 4, 3),
                '> li': { listStyle: 'disc', listStylePosition: 'outsidee' },
              }}
            >
              <li>
                <a
                  href="/teleconsultation/article/la-telemedecine-ca-veut-dire-quoi/la-teleexpertise-quest-ce-que-cest"
                  target="_blank"
                  rel="noopener"
                >
                  La téléexpertise
                </a>{' '}
                échange d’avis à distance, entre praticiens, sur le cas d’un
                patient.
              </li>
              <li>
                <a
                  href="/teleconsultation/article/la-telemedecine-ca-veut-dire-quoi/la-telesurveillance-medicale-quest-ce-que-cest"
                  target="_blank"
                  rel="noopener"
                >
                  La télésurveillance médicale
                </a>{' '}
                analyse à distance des données médicales d’un patient.
              </li>
              <li>
                <b>La téléconsultation</b> consultation en visio entre un
                praticien et un patient.
              </li>
              <li>
                <a
                  href="/teleconsultation/article/la-telemedecine-ca-veut-dire-quoi/la-teleassistance-quest-ce-que-cest"
                  target="_blank"
                  rel="noopener"
                >
                  La téléassistance
                </a>{' '}
                alternative aux hospitalisations et aux centres d’accueil pour
                les personnes âgées.
              </li>
              <li>
                <a
                  href="/teleconsultation/article/la-telemedecine-ca-veut-dire-quoi/medecin-regulateur"
                  target="_blank"
                  rel="noopener"
                >
                  La régulation médicale
                </a>{' '}
                acte médicale téléphonique d’urgence.
              </li>
            </Stack>
          </Typography>

          <Box mb={2}>
            <Typography variant={isMobile ? 'h6' : 'h5'} component="h3">
              Pour aller plus loin
            </Typography>

            <Stack spacing={1}>
              <a
                href="/teleconsultation/article/la-telemedecine-ca-veut-dire-quoi/quest-ce-que-le-telediagnostic"
                target="_blank"
                rel="noopener"
              >
                Le télédiagnostic, un diagnostic à distance sur une radio
              </a>
            </Stack>
          </Box>
        </Box>
      </CardsWrapper>
    </Box>
  );
};

export default TlcWhatIsItSection;
